export default __webpack_public_path__ + "a0cc858512521627e4c73e0bc6d9e549.png";